import { IAlertConfig, TdAlertDialogComponent, TdDialogService } from '@covalent/core/dialogs';
import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { ComponentType } from '@angular/cdk/overlay';
import { Router } from '@angular/router';

@Injectable()
export class ModalHelper {

  constructor(private router: Router, private dialog: MatDialog, private dialogService: TdDialogService) { }

  public open<T>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    data: any,
    viewContainerRef?: ViewContainerRef): MatDialogRef<T> {

    const {width, height, minWidth} = data;

    return this.dialog.open(componentOrTemplateRef, {
      minWidth: minWidth,
      width: width,
      height: height,
      data: data,
      viewContainerRef: viewContainerRef,
      disableClose: true
    });
  }

  public openConfirmDelete(message: string) {
    return this.dialogService.openConfirm({
      message: message,
      title: 'Confirm Deletion',
      acceptButton: 'Delete',
      cancelButton: 'Cancel'
    });
  }

  public openConfirm(confirmationMessage?: string | null) {
    return this.dialogService.openConfirm({
      message: confirmationMessage || 'Are you sure?',
      title: 'Confirmation',
      acceptButton: 'Continue'
    });
  }

  public openAlert(alertConfig: IAlertConfig): MatDialogRef<TdAlertDialogComponent> {
    return this.dialogService.openAlert(alertConfig);
  }

  public openPrompt(confirmationMessage?: string | null) {
    return this.dialogService.openPrompt({
      message: confirmationMessage || 'Are you sure?',
      title: 'Confirmation',
      value: '',
      acceptButton: 'Continue'
    });
  }
}
